// extracted by mini-css-extract-plugin
export default {"Section":"Section_Section__V-2xa"};